<div class="full-screen-container">
  <section class="forgot-password">

    <form
      [formGroup]="forgotPasswordForm"
      (ngSubmit)="onSubmit()"
      class="forgot-password_form space-y-6"
      *ngIf="!submitted; else showSuccess"
    >
    <header>
      <h2>Forgot Password</h2>
    </header>
    <div>
      <label for="email" class="block text-sm font-medium text-gray-800 mb-2">
        Email Address
      </label>
      <div class="relative">
        <input
          id="email"
          type="email"
          formControlName="email"
          placeholder="Enter your email"
          class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
          [class.border-red-300]="isFieldInvalid()"
          [class.border-gray-300]="!isFieldInvalid()"
          [class.focus:border-red-500]="isFieldInvalid()"
          [class.focus:ring-red-500]="isFieldInvalid()"
        >
        @if (isFieldInvalid()) {
          <div class="mt-2 text-sm text-red-600 flex items-center">
            <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
            </svg>
            @if (forgotPasswordForm.get('email').errors?.['required']) {
              Email is required.
            } @else if (forgotPasswordForm.get('email').errors?.['email']) {
              Please enter a valid email address.
            }
          </div>
        }
      </div>
    </div>
    <button [disabled]="!forgotPasswordForm.valid" type="submit" class="button button--brand">
      Submit
    </button>
    </form>

    <ng-template #showSuccess>
      <div class="success">
        <i class="fa fa-5x fa-check-circle"></i>
        <p>An email has been sent with a link to reset your password</p>
      </div>
    </ng-template>


</section>

</div>

